const ajiConfig = {
  title: "歡迎使用阿記",
  firstContent:
    "歡迎使用阿記，一個由社會網絡分析平台所提供的AI服務，用戶可於下方欄位輸入問題，希望我能為您提供所需的幫助！",
  secondContent: "(該服務將不會存儲對話資料。)",
  quota: 5,
  downloadFileName: "阿記對話紀錄.txt",
  monthSubQuotaTitle: "AI月訂閱制可用額度 ",
  monthSubQuota: "無限制",
  freeQuotaTitle: "AI可免費使用額度剩 ",
  freeQuotaUpdateTitle: " (每日00:00更新)",
  freeQuotaUpdateHour: 0,
  freeQuotaUpdateMinute: 0,
  msgType: {
    ai: "AI",
    user: "User",
  },
  sourceTitle: "引用資料：",
  rate: {
    bad: "0",
    good: "1",
  },
};

export default ajiConfig;
